
import { connect } from 'react-redux';
var moment = require('moment');

let DateFormat = ({ date, dateFormatt }) => {
  const displayDate = moment(date).format(dateFormatt);
  if (displayDate === 'Invalid date') {
    return '';
  }
  return displayDate;
}

const viewMapStateToProps = (state) => {
  return {
    dateFormatt: state.User.dateFormat
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

DateFormat = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(DateFormat);
export default DateFormat;



// WEBPACK FOOTER //
// ./src/lib/date/DateFormat.js